import {
  FlexCenterColumn,
  FlexCenterLine,
  FlexDiv,
  FlexSpaceBetween,
} from "./components/Layout";
import {
  AppContent,
  AppLayout,
  BrandRow,
  DashboardIcon,
  SiderLogo,
  StyledBtnDiv,
  StyledToggle,
  TextLogo,
} from "./AppStyle";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import {
  faChevronLeft,
  faChevronRight,
  faList,
  faPlus,
  faTicketAlt,
} from "@fortawesome/free-solid-svg-icons";

import dashboardIcon from "./assets/images/dashboardIcon.svg";
import trainingIcon from "./assets/images/trainingIcon.svg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListTickets } from "./pages/ListTickets";
import { IRoute } from "./common/types";
import JulebLogo from "./assets/images/juleblogo.svg";
import { CreateTicket } from "./pages/CreateTicket";
import { DisplayTicket } from "./pages/DisplayTicket";
import { StyleMenuItem } from "./components/Juleb";
import { SurveyDialog } from "./components/SurveyDialog";
import { Button, Layout, Menu } from "antd";
import { useEffect, useState } from "react";
import { Header } from "antd/lib/layout/layout";
import { Margin } from "./components/Spacing";
import { Usermenu } from "./components/UserMenu";
import { useAppContext } from "./context/app/context";
import TrainingPortal from "./pages/TrainingPortal";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "./common/constants";

const { Content, Sider } = Layout;
export function AppRoute() {
  const [displayedSurvey, setDisplayedSurvey] = useState(false);
  const location = useLocation();
  const appContext = useAppContext();
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState([location.pathname]);

  const [collapsed, setCollapsed] = useState(false);
  const toggle = () => {
    setCollapsed(!collapsed);
  };

  // -------- Set language -------------
  const { state } = useAppContext();
  const language = state.odooSession?.user_context.lang;
  const { t, i18n } = useTranslation();
  console.log(language)

  useEffect(() => {
    language === 'ar_001'
      ? i18n.changeLanguage(SUPPORTED_LANGUAGES.AR)
      : i18n.changeLanguage(SUPPORTED_LANGUAGES.EN);
  }, [language, i18n]);
  //------------------------------------
  const AppRoutes: IRoute[] = [
    {
      title: t("menu.create_ticket"),
      path: "/",
      index: true,
      showOnMenu: true,
      component: <CreateTicket />,
      icon: <FontAwesomeIcon icon={faPlus} />,
    },
    {
      title: t("menu.show_tickets"),
      path: "/list",
      showOnMenu: true,
      component: <ListTickets />,
      icon: <FontAwesomeIcon icon={faList} />,
    },
    {
      title: "Display Ticket",
      path: "/ticket",
      showOnMenu: false,
      component: <DisplayTicket />,
      icon: <FontAwesomeIcon icon={faTicketAlt} />,
    },
    {
      title: t("menu.training_portal"),
      path: "/trainingPortal",
      showOnMenu: true,
      component: <TrainingPortal/>,
      icon: <img src={trainingIcon} alt="" />,
    },
  ];
  return (
    <AppLayout>
      <SurveyDialog
        isVisible={displayedSurvey}
        onCancel={() => {
          setDisplayedSurvey(false);
        }}
      />
      <AppLayout>
        <AppContent>
          <Header>
            <FlexSpaceBetween>
              <TextLogo>
                <DashboardIcon
                  onClick={() => {
                    window.location.replace(`${window.location.origin}/web`);
                  }}
                >
                  <img src={dashboardIcon} alt="" />
                </DashboardIcon>
                {t("title")}
              </TextLogo>
              <FlexCenterLine
                style={{
                  paddingRight: 20,
                }}
              >
                <StyledBtnDiv>
                  <Button
                    shape="round"
                    onClick={() => {
                      setDisplayedSurvey(!displayedSurvey);
                    }}
                    type="default"
                  >
                    Take survey
                  </Button>
                </StyledBtnDiv>

                <Margin right={20} />
                <Usermenu user={appContext.state.odooSession?.name || "..."} />
              </FlexCenterLine>
            </FlexSpaceBetween>
          </Header>
          <Layout className="site-layout">
            <FlexDiv>
              <Sider collapsible collapsed={collapsed}>
                <BrandRow
                  style={{
                    justifyContent: collapsed ? "center" : "space-between",
                  }}
                >
                  {!collapsed && <SiderLogo src={JulebLogo} alt="Juleb" />}
                  <StyledToggle onClick={toggle}>
                    {collapsed ? (
                      <FontAwesomeIcon icon={faChevronRight} />
                    ) : (
                      <FontAwesomeIcon icon={faChevronLeft} />
                    )}
                  </StyledToggle>
                </BrandRow>
                <Menu selectedKeys={selectedItem} theme="light" mode="inline">
                  {AppRoutes.filter((route) => route.showOnMenu).map(
                    (route, i) => (
                      <StyleMenuItem
                        onClick={() => {
                          navigate(route.path);
                          setSelectedItem([route.path]);
                        }}
                        key={route.path}
                        icon={route.icon}
                      >
                        {!collapsed && route.title}
                      </StyleMenuItem>
                    )
                  )}
                </Menu>
              </Sider>

              <Content
                style={{
                  margin: "24px 16px",
                  padding: 24,
                  minHeight: 280,
                }}
              >
                <Routes>
                  {AppRoutes.map((route) => {
                    if (route?.index) {
                      return (
                        <Route
                          key={route.path}
                          index
                          element={route.component}
                        />
                      );
                    } else {
                      return (
                        <Route
                          key={route.path}
                          path={route.path}
                          element={route.component}
                        />
                      );
                    }
                  })}
                </Routes>
              </Content>
            </FlexDiv>
          </Layout>
        </AppContent>
      </AppLayout>
    </AppLayout>
  );
}
